import {
  EbankingServiceRoleProperties,
  ProductSpecificServiceAgreementProperties,
  ProductSpecificServiceRoleProperties,
  SafeDepositBoxServiceAgreementProperties,
  SafeDepositBoxServiceRoleProperties,
  WealthPlanningServiceAgreementProperties,
} from 'pco-product-service-internal-consumer';

export const isEbankingServiceRoleProperties = (
  properties: ProductSpecificServiceRoleProperties | undefined,
): properties is { propertiesType: 'EBANKING' } & EbankingServiceRoleProperties =>
  properties?.propertiesType === 'EBANKING';

export const isSafeDepositBoxServiceRoleProperties = (
  properties: ProductSpecificServiceRoleProperties | undefined,
): properties is { propertiesType: 'SAFE_DEPOSIT_BOX' } & SafeDepositBoxServiceRoleProperties =>
  properties?.propertiesType === 'SAFE_DEPOSIT_BOX';

export const isSafeDepositBoxServiceAgreementProperties = (
  properties: SafeDepositBoxServiceAgreementProperties | undefined,
): properties is { propertiesType: 'SAFE_DEPOSIT_BOX' } & SafeDepositBoxServiceAgreementProperties =>
  properties?.propertiesType === 'SAFE_DEPOSIT_BOX';

export const isWealthPlanningServiceAgreementProperties = (
  properties: ProductSpecificServiceAgreementProperties | undefined,
): properties is { propertiesType: 'WEALTH_PLANNING' } & WealthPlanningServiceAgreementProperties =>
  properties?.propertiesType === 'WEALTH_PLANNING';
